import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

import { OrderSummaryCard } from "../../components/OrderSummaryCard";

interface ISelfServeContentWrapperProps {
  leftSection: React.ReactNode;
}

export const SelfServeContentWrapper: React.FC<
  ISelfServeContentWrapperProps
> = ({ leftSection }) => {
  const { isTabletAndAbove } = useViewport();

  return (
    <Row data-test-id="self-serve-surface-wrapper">
      <LeftPanelWrapper data-test-id="left-panel-wrapper">
        <LeftPanelInnerWrapper data-test-id="left-panel-inner-wrapper">
          {leftSection}
        </LeftPanelInnerWrapper>
      </LeftPanelWrapper>
      {isTabletAndAbove ? (
        <>
          <OrderSummaryCard />
          <Spacer width="1x" />
        </>
      ) : null}
    </Row>
  );
};

const LeftPanelWrapper = styled.div`
  width: 100%;
  padding: ${getSpacing("4x")};
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("2x")};
  }
  background-color: ${Core.surface.inverse};
  min-height: 75vh;
`;

const LeftPanelInnerWrapper = styled.div`
  ${responsiveMediaQueries.mobile} {
    min-width: 0px;
  }
  width: 100%;
`;
